// extracted by mini-css-extract-plugin
export var chip = "_mi-2";
export var chipBody = "_mi-8";
export var chipHeader = "_mi-9";
export var chipWithKind = "_mi-7";
export var icon = "_mi-3";
export var kind = "_mi-a";
export var remove = "_mi-5";
export var removeIcon = "_mi-6";
export var row = "_mi-0";
export var rowHistorical = "_mi-1";
export var text = "_mi-4";